import { DeviceManifest } from '@rapoo/device-sdk'
import {
  dpi45kStepped,
  mouseMacro,
  mousePerfCap,
  parametersLiftoffLow,
  retailMouseConfig,
} from './generate/capabilityPresets'

/**
 * VT9 MAX 设备清单
 **/
const rapooVT9MAX: DeviceManifest = {
  channel: ['china_game', 'global'],
  model: 'VT9 MAX',
  mainControl: 'VT9MAX',
  dongleModel: 'Dongle_NordicL5',
  type: 'mouse',
  version: '1.0.0',
  hardware: {
    vendorId: 0x24ae,
    productId: [0x4618, 0x1418],
    currentPid: 0x4618,
    transport: 'HID',
    filters: [
      {
        usagePage: 65280,
        usage: 2,
        description: 'Configuration Interface (Secondary)',
        type: 'default',
      },
      {
        usagePage: 65280,
        usage: 14,
        description: 'Only update Firmware',
        type: 'update',
      },
      {
        usagePage: 65280,
        usage: 1,
        description: 'Only update WCH Firmware',
        type: 'updateWCH',
      },
    ],
  },
  driver: 'VT_nrf54L',
  MCU: 'N54L15',
  sensor: 'PAW3950U',
  microSwitch: 'optical',
  encoder: 'mechanical',
  battery: 800,
  ui: {
    assetsDir: 'manifests/VT9 MAX',
    colors: {
      series: [
        {
          name: 'common.products.VT9_MAX.Black',
          value: '#2B2B2B',
          key: 'Black',
        },
        {
          name: 'common.products.VT9_MAX.White',
          value: '#F8FAFF',
          key: 'White',
        },
        {
          name: 'common.products.VT9_MAX.Electric_Purple',
          value: '#684091',
          key: 'Electric_Purple',
        },
      ],
      current: 'Black',
    },
    icon: 'Hardware-Wireframe-Mouse',
    overview: true,
  },
  capabilities: [
    retailMouseConfig,
    parametersLiftoffLow,
    dpi45kStepped,
    mouseMacro,
    mousePerfCap({
      tier: 'retail',
      sensorScanRateLabel: '13K',
      keyScanRate: true,
      rfPacketType: 'wirelessOnly',
    }),
  ],
  layout: {
    keys: [
      [
        {
          key: 0,
          keywords: '左击',
          x: -25,
          y: 50,
          alignLeft: false,
          url: 'mouse left',
        },
        {
          key: 1,
          keywords: '中键',
          x: 240,
          y: 52,
          alignLeft: true,
          url: 'roller middle',
        },
        {
          key: 2,
          keywords: '右击',
          x: 240,
          y: 156,
          alignLeft: true,
          url: 'mouse right',
        },
        {
          key: 3,
          keywords: 'DPI+',
          x: 240,
          y: 208,
          alignLeft: true,
          url: 'dpi+',
        },
        {
          key: 4,
          keywords: 'DPI-',
          x: 240,
          y: 260,
          alignLeft: true,
          url: 'dpi-',
        },
        {
          key: 5,
          keywords: '右侧',
          x: -25,
          y: 132,
          alignLeft: false,
          url: 'mouse forward',
        },
        {
          key: 6,
          keywords: '左侧',
          x: -25,
          y: 195,
          alignLeft: false,
          url: 'mouse back',
        },
        {
          key: 9,
          keywords: '上滚',
          x: 240,
          y: 0,
          alignLeft: true,
          url: 'roller up',
        },
        {
          key: 10,
          keywords: '下滚',
          x: 240,
          y: 104,
          alignLeft: true,
          url: 'roller down',
        },
        {
          key: 13,
          keywords: 'DIY',
          x: 655,
          y: 118,
          alignLeft: true,
          url: 'diy',
        },
      ],
    ],
  },
}

export default rapooVT9MAX
